import "./__tab.scss"; import "./tabs.scss"

